/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  return typeof str === 'string' || str instanceof String;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

//注册页字段常量对应描述
export function zhuceyeConst(){
  return [
    {
      key:'name',
      value:'企业名称'
    },
    {
      key:'phone',
      value:'联系人手机号'
    },
    {
      key:'password',
      value:'密码'
    },
    {
      key:'rePassWord',
      value:'再次输入密码'
    },
    {
      key:'people',
      value:'企业法人'
    },
    {
      key:'enroll_amounts',
      value:'注册资金'
    },
    {
      key:'tax_number',
      value:'营业执照'
    },
    {
      key:'enroll_time',
      value:'成立日期'
    },
    {
      key:'type',
      value:'企业性质'
    },
    {
      key:'address',
      value:'详细地址'
    },
    {
      key:'people_name',
      value:'联系人姓名'
    },
    {
      key:'people_type',
      value:'职务'
    },
    {
      key:'seller_phone',
      value:'公司电话'
    },
    {
      key:'mail',
      value:'邮箱'
    },
    {
      key:'bank_name',
      value:'开户名'
    },
    {
      key:'bank',
      value:'开户行'
    },
    {
      key:'bank_number',
      value:'银行卡号'
    }
  ]
}
